import styled from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const Box = styled.div`
  padding: 0 0 200px 0;

  /* LP : 좌우 여백 없이 2열. 실제 ProductList(ItemsGrid) 와 같이 gap 없이 붙인다 */
  .box-lp {
    ${mixin.flex({ justify: 'flex-start', align: 'flex-start', wrap: 'wrap' })};
    margin-top: 40px;
    row-gap: 36px;
    column-gap: 1px;

    .item {
      flex: 1;

      /* 폭이 유동이라 높이 대신 비율(상품 이미지 3:4)로 잡는다 */
      .thum {
        width: 100%;
        height: 0;
        padding-bottom: 133.33%;
      }

      .text01 {
        margin: 8px 0 0 8px;
        width: 154px;
        height: 20px;
        border-radius: 4px;
      }

      .text02 {
        margin: 4px 0 0 8px;
        width: 154px;
        height: 20px;
        border-radius: 4px;
      }

      .text03 {
        margin: 4px 0 0 8px;
        width: 80px;
        height: 20px;
        border-radius: 4px;
      }
    }
  }

  @media ${({ theme }) => `${theme.media.smMax}, ${theme.media.md}`} {
    padding: ${mixin.pxToVw('0 0 200 0')};

    .box-lp {
      margin-top: ${mixin.pxToVw('40')};
      row-gap: ${mixin.pxToVw('36')};

      .item {
        .text01 {
          margin: ${mixin.pxToVw('8 0 0 8')};
          width: ${mixin.pxToVw('154')};
          height: ${mixin.pxToVw('20')};
          border-radius: ${mixin.pxToVw('4')};
        }

        .text02 {
          margin: ${mixin.pxToVw('4 0 0 8')};
          width: ${mixin.pxToVw('154')};
          height: ${mixin.pxToVw('20')};
          border-radius: ${mixin.pxToVw('4')};
        }

        .text03 {
          margin: ${mixin.pxToVw('4 0 0 8')};
          width: ${mixin.pxToVw('80')};
          height: ${mixin.pxToVw('20')};
          border-radius: ${mixin.pxToVw('4')};
        }
      }
    }
  }
`;
